const isSuperAdmin = (user) => {
    if (user && user.profile.PROFILE === 'SUPER ADMINISTRADOR') {
        return true;
    }
    else {
        return false;
    }
}

const isUNGE = (user) => {
    if (user && user.profile.COMPANY === 'UNGE') {
        return true;
    }
    else {
        return false;
    }
}

const isSINES = (user) =>{
    if (user && user.profile.COMPANY === 'SINES') {
        return true;
    }
    else {
        return false;
    }
}

const isRIBATEJO = (user) =>{
    if (user && user.profile.COMPANY === 'RIBATEJO') {
        return true;
    }
    else {
        return false;
    }
}

const isLARES = (user) =>{
    if (user && user.profile.COMPANY === 'LARES') {
        return true;
    }
    else {
        return false;
    }
}

const isCTCH = (user) =>{
    if (user && user.profile.COMPANY === 'CTCH') {
        return true;
    }
    else {
        return false;
    }
}

const isIndipsAdmin = (user) =>{
    if (user && user.profile.PROFILE === 'INDISPS ADMIN') {
        return true;
    }
    else {
        return false;
    }
}

const isReader = (user) =>{
    if (user && user.profile.PROFILE === 'READER') {
        return true;
    }
    else {
        return false;
    }
}

const isDGEHC = (user) =>{
    if (user && user.profile.COMPANY === 'DGE_HC') {
        return true;
    }
    else {
        return false;
    }
}

const isGDEHC = (user) =>{
    if (user && user.profile.COMPANY === 'GDE_HC') {
        return true;
    }
    else {
        return false;
    }
}

const isPRODHC = (user) =>{
    if (user && user.profile.COMPANY === 'PROD_HC') {
        return true;
    }
    else {
        return false;
    }
}

const isCOMHC = (user) =>{
    if (user && user.profile.COMPANY === 'COM_HC') {
        return true;
    }
    else {
        return false;
    }
}
const isGDEABO = (user) =>{
    if (user && user.profile.COMPANY === 'GDE_ABO') {
        return true;
    }
    else {
        return false;
    }
}
module.exports = {
    isSuperAdmin,
    isUNGE,
    isCTCH,
    isSINES,
    isRIBATEJO,
    isLARES,
    isIndipsAdmin,
    isReader,
    isDGEHC,
    isGDEHC,
    isPRODHC,
    isCOMHC,
    isGDEABO
};



// WEBPACK FOOTER //
// ./src/utils/user-profile.js